import {
  REMOVE_AREA_ENTRY_STRATEGY,
  REMOVE_AREA_ENTRY_STRATEGY_FAILED,
  REMOVE_AREA_ENTRY_STRATEGY_SUCCESSFUL,
} from './actionTypes';

export const removeAreaEntryStrategy = ({ updatedBy, areaId, token, history }) => {
  console.log('removeAreaEntryStrategy action called with:', { updatedBy, areaId, token });
  return {
    type: REMOVE_AREA_ENTRY_STRATEGY,
    payload: { updatedBy, areaId, token, history },
  };
};

export const removeAreaEntryStrategySuccessful = (message) => {
  return {
    type: REMOVE_AREA_ENTRY_STRATEGY_SUCCESSFUL,
    payload: message,
  };
};

export const removeAreaEntryStrategyFailed = (message) => {
  return {
    type: REMOVE_AREA_ENTRY_STRATEGY_FAILED,
    payload: message,
  };
};
